import React from "react";
import sliderImg from "../../assets/images/IZB/IZB Website Skin/Home_Page/banner.png";
import { FiCheckCircle } from "react-icons/fi";
import BankingMenu from "./BankingMenu";
import "./Hero.css";
import { Link } from "react-router-dom";

const HeroSlide5 = () => {
const fastserve = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-fast-serve_png.png";

  // const HeroBgimg = {
  //   height: "75vh",
  //   backgroundRepeat: "no-repeat",
  //   backgroundSize: "100%",
  //   overflow: "hidden",
  // };

  return (
    <Link to="">
      {/* <div style={HeroBgimg} className="HeroSlider5">
        <div className="auto-container sliderContent h-100">
          <div className="h-75 position-relative ">
            <div className="d-flex justify-content-end align-items-center h-100">
              <div className="pt-4">
        
              </div>
             
              <div className="flex-column flex-wrap align-self-xl-center">
              
        
              </div>
            </div>
          </div>
        </div>
      </div> */}

     
      
      <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_NXT_Corporate App_Banner_2.png" alt="hero-banner-desktop" className="hide-on-mobile home-hero-banner" />
      <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_NXT_Corporate App_Mobile_Banner_2.png" alt="hero-banner-mobile" className="hide-on-desktop home-hero-banner" />

      {/* <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_BANNER_House_desktop 1.jpg" alt="hero-banner-desktop" className="hide-on-mobile home-hero-banner" />
      <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_BANNER_House_mobile1.jpg" alt="hero-banner-mobile" className="hide-on-desktop home-hero-banner" /> */}
    </Link>
  );
};

export default HeroSlide5;